import { useSelector } from "react-redux";
import { EBenefitTypes, EShowMode } from "../enums/benefits.enums";
import { selectDecision, selectEntitlement } from "../redux/benefits.selectors";

type UseBenefitOptions = {
    showWhenBlocked?: EShowMode;
};

export function useBenefit(type: EBenefitTypes, options?: UseBenefitOptions) {
    const showWhenBlocked = options?.showWhenBlocked ?? EShowMode.DISABLED;

    const entitlement = useSelector(selectEntitlement(type));
    const decision = useSelector(selectDecision(type, showWhenBlocked));

    return {
        entitlement,
        decision,
        canUseNow: decision.mode === EShowMode.ENABLED,
        mode: decision.mode,
    };
}
